import { SharinSingleCollaboratorDetailsResponse } from '@/app/models/sharingDetails';
import formatterMonetaryValue from '@/app/utils/numberUtils';
import formatterPercentualValue from '@/app/utils/percentualUtils';
import { styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const HeaderTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 13,
  fontWeight: 'bold',
  padding: theme.spacing(1),
  backgroundColor: theme.palette.grey[200],
}));

const RowTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 13,
  padding: theme.spacing(1),
}));

type RuleClassificationTableGridParams = {
  rows: SharinSingleCollaboratorDetailsResponse;
};

function SharingCollaboratorTableHeader({ rows }: RuleClassificationTableGridParams) {
  const { t } = useTranslation('sharingDetails');

  if (!rows) {
    return (
      <Typography variant="subtitle2" sx={{ mt: 2 }}>
        {t('no.data.found')}
      </Typography>
    );
  }

  return (
    <TableContainer sx={{ marginLeft: 0, padding: 0, width: '100%' }}>
      <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
        <TableHead>
          <TableRow>
            <HeaderTableCell colSpan={4}>{t('collaborator')}</HeaderTableCell>
            <HeaderTableCell>{t('salary.total')}</HeaderTableCell>
            <HeaderTableCell align="center">{t('percentual')}</HeaderTableCell>
            <HeaderTableCell>{t('paid')}</HeaderTableCell>
            <HeaderTableCell align="center">{t('hours.month')}</HeaderTableCell>
            <HeaderTableCell align="center">{t('hours.allocated')}</HeaderTableCell>
            <HeaderTableCell align="center">{t('workload')}</HeaderTableCell>
            <HeaderTableCell />
            <HeaderTableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <RowTableCell colSpan={4}>{rows.name}</RowTableCell>
            <RowTableCell>{formatterMonetaryValue(rows.salary)}</RowTableCell>
            <RowTableCell align="center">{formatterPercentualValue(rows.percent)}</RowTableCell>
            <RowTableCell>{formatterMonetaryValue(rows.value)}</RowTableCell>
            <RowTableCell align="center">{`${rows.monthlyWorkingHours}h`}</RowTableCell>
            <RowTableCell align="center">{`${rows.percentageHoursWorkedOnMonth}h`}</RowTableCell>
            <RowTableCell align="center">{`${rows.dailyWorkingHours}h`}</RowTableCell>
            <RowTableCell />
            <RowTableCell />
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default SharingCollaboratorTableHeader;
